import React from 'react';
export const Dialog = ({ children, open, onOpenChange }) => open ? <div className="fixed inset-0 z-50 flex items-center justify-center">{children}</div> : null;
export const DialogTrigger = ({ children, onClick }) => <div onClick={onClick}>{children}</div>;
export const DialogContent = ({ children }) => <div className="bg-white rounded-lg p-6">{children}</div>;
export const DialogHeader = ({ children }) => <div className="mb-4">{children}</div>;
export const DialogTitle = ({ children }) => <h2 className="text-xl font-bold">{children}</h2>;
export const DialogDescription = ({ children }) => <p className="text-sm text-gray-500">{children}</p>;
export const DialogFooter = ({ children }) => <div className="mt-4 flex justify-end">{children}</div>;
